import React from 'react';
import './ButtonSecondary.scss';

export default function ButtonSecondary({ children, className, onClick, href, onMouseEnter, onMouseLeave}) {
    const classes = `btn-secondary ${className}`;

    return href ? (
        <a href={href} className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div className="btn-content">
                {children}
            </div>
        </a>
    ) : (
        <button className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div className="btn-content">
                {children}
            </div>
        </button>
    );
}
